export default __webpack_public_path__ + "static/media/goal_fail.68264bd2.svg";